import React from 'react';
import { Row, Col } from 'antd';
import Menu from './menu';
import './index.less'
import Icon from '@/assets/images/logo.png';

const NavBar: React.FC<any> = props => {
  return (
    <Row align={'middle'} justify="space-between" className="nav">
      <Col>
        <Row>
          <img height={48}  className="logo" src={Icon} alt="" />
          <Menu />
        </Row>
      </Col>
    </Row>

  )
}


export default NavBar
